import _ from 'lodash';

export const transformTabGroup = (item) => ({
  ...item,
  tabs: _.sortBy(item.tabs, 'position'),
});
export const transformTabGroups = (data) => data.map((item) => transformTabGroup(item));
